// extracted by mini-css-extract-plugin
export var alternate = "_j-h";
export var black = "_j-3";
export var blue = "_j-d";
export var blueLight = "_j-c";
export var brand = "_j-7";
export var error = "_j-9";
export var gray = "_j-6";
export var grayBlue = "_j-b";
export var iconWrapper = "_j-4";
export var indigo = "_j-e";
export var orange = "_j-g";
export var pink = "_j-f";
export var primary = "_j-0";
export var purple = "_j-8";
export var success = "_j-5";
export var warning = "_j-a";
export var white = "_j-1";
export var whiteSuccess = "_j-2";